import { Paper } from '@mui/material';
import { t } from 'i18next';
import { SEVERITY_COLORS, Severity, getLabel } from '../../../../common/enums/Severity';
import { SeverityChart } from '../../common/components/SeverityChart';
import { InstancesCounters } from '../models/valueObjects/InstancesCounters';

type Props = {
  counters: InstancesCounters;
};

export const InstancesChart = ({ counters }: Props) => {
  const chartData = [
    { s: Severity.HIGH, v: counters.getHigh() },
    { s: Severity.MED, v: counters.getMedium() },
    { s: Severity.LOW, v: counters.getLow() },
    { s: Severity.PASSED, v: counters.getPassed() },
    { s: Severity.FILTERED, v: counters.getNotKept() },
  ].map(({ s, v }) => ({
    name: getLabel(s),
    amount: v,
    color: SEVERITY_COLORS[s].main,
    textColor: SEVERITY_COLORS[s].text,
    backgroundColor: SEVERITY_COLORS[s].background,
  }));

  return (
    <Paper>
      <SeverityChart title={t('instances')} items={chartData} layout="row" padding={2} />
    </Paper>
  );
};
